import React, { useState, useEffect } from 'react';
import {
  TextField,
  Button,
  Box,
  Typography,
  CircularProgress,
  Container,
  Paper,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';
import api from '../utils/api';

const SpotRegistration = ({ eventName }) => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    organization: '',
    reg_no: '',
    email: '',
    event: eventName
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const response = await api.post('/api/spot-registration/', {
        ...formData,
        event: eventName
      });
      setSuccess('Registration completed successfully!');
      setFormData({
        reg_no: '',
        name: '',
        phone: '',
        organization: '',
        email: '',
        event: eventName
      });
    } catch (err) {
      setError('Failed to register. Please try again.');
      console.error('Error during registration:', err);
    } finally {
      setLoading(false);
    }
  };

  if (!eventName) {
    return (
      <Typography variant="h6" color="error">
        No event selected. Please select an event first.
      </Typography>
    );
  }

  return (
    <Container maxWidth="md">
      <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
        <Typography variant="h4" gutterBottom>
          Spot Registration - {eventName}
        </Typography>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
          <TextField
            fullWidth
            label="Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            margin="normal"
          />
          <TextField
            fullWidth
            label="Phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            required
            margin="normal"
          />
          <TextField
            fullWidth
            label="Email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            margin="normal"
            type="email"
          />
          <FormControl fullWidth margin="normal">
            <InputLabel>Organization</InputLabel>
            <TextField
              name="organization"
              value={formData.organization}
              onChange={handleChange}
              required
              margin="normal"
            />
          </FormControl>
          <TextField
            fullWidth
            label="Registration Number"
            name="reg_no"
            value={formData.reg_no}
            onChange={handleChange}
            margin="normal"
          />
          {error && (
            <Typography color="error" sx={{ mt: 2 }}>
              {error}
            </Typography>
          )}
          {success && (
            <Typography color="success.main" sx={{ mt: 2 }}>
              {success}
            </Typography>
          )}
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 3 }}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : 'Register'}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default SpotRegistration;
